import theme from '../../../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  container: {
    ...layouts.column,
    alignItems: 'center',
    padding: `${scale.s} ${scale.xs} ${scale.l}`,

    '> div': {
      flexDirection: 'row',
      gap: '1rem',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },

  blockItem: {
    display: 'flex',
    flex: '1 0 30%',
    maxWidth: '30%',
    margin: '0 !important',

    [media.l.down]: {
      flex: '1 0 48%',
      maxWidth: '48%',
    },

    [media.s.down]: {
      flex: '1 0 100%',
      maxWidth: '100%',
    },

    '> a': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'stretch',
      color: colors.black,
      outline: 0,

      '> div': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },

      '&:hover label': {
        textDecoration: 'underline',
      },
    },

    img: {
      flexGrow: '1',
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
    },

    label: {
      padding: '0.5rem',
      fontWeight: 700,
      fontSize: '1.1rem',
    },
  },

  mobileImage: {
    [media.m.up]: {
      display: 'none',
    },
  },
  responsiveImage: {
    [media.s.down]: {
      display: 'none',
    },
  },
});
